import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import consent from '../../modules/consent';
import { useMap } from '../hooks';
import Checkbox from './Checkbox';

function GoogleMapsNotice({ enableMap }) {
  const { t } = useTranslation('dealers');
  const [consentType, setConsentType] = useState('session');
  const { setMapEnabled } = useMap();

  function handleConsentType(e) {
    setConsentType(e.target.checked ? 'local' : 'session');
  }

  function handleSave() {
    consent.setConsent({
      dealers: consentType
    });
    consent.updateConsent();

    setMapEnabled(!!enableMap);
  }

  return (
    <div className="google-maps-notice">
      <p>{t('Google maps marketing permission required')}</p>
      <Checkbox label={t('Remember consent')} checked={consentType === 'local'} onChange={handleConsentType} />

      <button type="button" className="button button--primary" data-consent={consentType} onClick={handleSave}>{t('Update consent')}</button>
    </div>
  );
}


GoogleMapsNotice.propTypes = {
  enableMap: PropTypes.bool,
};

export default GoogleMapsNotice;
